import { render, staticRenderFns } from "./help-center.vue?vue&type=template&id=ec8fd03e&scoped=true&lang=pug&"
import script from "./help-center.vue?vue&type=script&lang=js&"
export * from "./help-center.vue?vue&type=script&lang=js&"
import style0 from "./help-center.vue?vue&type=style&index=0&id=ec8fd03e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8fd03e",
  null
  
)

export default component.exports